import { render } from "./RoleDropdownV2.vue?vue&type=template&id=cc8a3b42"
import script from "./RoleDropdownV2.vue?vue&type=script&lang=js"
export * from "./RoleDropdownV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__